import React from "react";

function Lockicon() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.87265 17.1001C4.07671 18.6158 5.33205 19.8031 6.8597 19.8734C8.14514 19.9324 9.45093 19.9633 10.8889 19.9633C12.3269 19.9633 13.6326 19.9324 14.9181 19.8734C16.4458 19.8031 17.7011 18.6158 17.9052 17.1001C18.0384 16.1111 18.1482 15.0974 18.1482 14.0651C18.1482 13.0329 18.0384 12.0192 17.9052 11.0301C17.7011 9.51449 16.4458 8.32714 14.9181 8.25691C13.6326 8.19782 12.3269 8.16699 10.8889 8.16699C9.45093 8.16699 8.14514 8.19782 6.8597 8.25691C5.33205 8.32714 4.07671 9.51449 3.87265 11.0301C3.73948 12.0192 3.62964 13.0329 3.62964 14.0651C3.62964 15.0974 3.73948 16.1111 3.87265 17.1001Z"
        stroke="#424242"
        strokeWidth="1.36111"
      />
      <path
        d="M6.80566 8.16631V5.89779C6.80566 3.64263 8.63384 1.81445 10.889 1.81445C13.1442 1.81445 14.9723 3.64263 14.9723 5.89779V8.16631"
        stroke="#424242"
        strokeWidth="1.36111"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5186 14.0557V14.0647"
        stroke="#424242"
        strokeWidth="1.81481"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.8889 14.0557V14.0647"
        stroke="#424242"
        strokeWidth="1.81481"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.25928 14.0557V14.0647"
        stroke="#424242"
        strokeWidth="1.81481"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default Lockicon;
